import Pochta from "./Pochta";
function ESTP()
{
     return(
        <div className="Glavn">
  <div className='catalog' >
        <div className="image">
             <div className="image-wrapper">
       <img src="/img/ЕSTP Делец.png" className="bigESTP"/>
       </div>
      {/* <h1>Дипломат</h1>
      <h2>ENFP</h2> */}
       <div className="result">
         <h2>ESTP</h2>
 <p><strong>Процент населения:</strong> 4–6%</p>
<p><strong>Среди мужчин:</strong> 6–8%</p>
<p><strong>Среди женщин:</strong> 2–4%</p>
<p><strong>Стратегия:</strong> Действие и влияние</p>

<p><strong>Психологические особенности:</strong></p>
<p>
  ESTP черпают энергию из общения и активных действий. 
  Им нужно движение, риски и новые впечатления. 
  Они восстанавливают силы, участвуя в событиях и решая проблемы.
</p>
<p>
  Решения ESTP принимают на основе логики и быстрого анализа. 
  Они доверяют своей реакции и опыту. 
  Они ценят свободу, действие и возможность рисковать.
</p>
<p>
  Это энергичные и обаятельные люди. 
  Они всегда в центре событий и умеют убеждать. 
  Им трудно сидеть на месте, но их энергия заражает всех.
</p>

<p><strong>Особенность:</strong></p>
<p>
  ESTP — это авантюрист, который не думает о последствиях. Они говорят, что думают, 
  и могут обидеть нечаянно. Они не любят обязательства и могут исчезнуть, когда станет скучно. 
  Их импульсивность и тяга к риску часто пугают близких.
</p>

<p>
  ESTP — это человек, который может продать лёд в Антарктиде и всем понравится. 
  Они — магнит для приключений, и их жизнь — серия событий, а не скучных дней. 
  С ними никогда не скучно. И именно поэтому их так любят... и боятся.
</p>

  </div>
  <Pochta/>
  </div>
   </div>
    </div>
       );
}
export default ESTP;